import * as React from 'react';
import { CSSProperties, PropsWithChildren } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { IRootState } from 'reducer';

interface IStylingProps {
  isSidebarOpen: boolean;
  withoutTopPanel?: boolean;
  fullscreen: boolean;
  noPadding? : boolean;
}

const StyledBody = styled.div<IStylingProps>`
  padding: ${({ withoutTopPanel, fullscreen }) => {
    if (fullscreen) return 0;
    return withoutTopPanel ? '0 16px' : '44px 16px 0';
  }};
  @media (min-width: 816px) {
    margin-left: ${({ isSidebarOpen, fullscreen }: IStylingProps) => {
      if (fullscreen) return 0;
      return isSidebarOpen ? '255px' : '';
    }};
    padding: ${({ withoutTopPanel, fullscreen, noPadding }) => {
      if (fullscreen || noPadding) return 0;
      return withoutTopPanel ? '0 32px' : '44px 32px 0';
    }};
  }

  .ms-DetailsHeader {
    padding-top: 0;
  }
`;

interface IProps {
  isSidebarOpen: boolean;
  style?: CSSProperties;
  withoutTopPanel?: boolean;
  fullscreen: boolean;
  noPadding? : boolean;
}

const PageBody: React.FC<IProps> = ({
  isSidebarOpen,
  children,
  withoutTopPanel,
  fullscreen,
  noPadding,
  ...props
}) => {
  return (
    <StyledBody
      isSidebarOpen={isSidebarOpen && !fullscreen}
      withoutTopPanel={withoutTopPanel || fullscreen}
      fullscreen={fullscreen}
      noPadding={noPadding}
      {...props}
    >
      {children}
    </StyledBody>
  );
};

const mapStateToProps = ({ app }: IRootState) => ({
  fullscreen: app.fullscreen,

  isSidebarOpen: app.isSideBarOpen,
});

export default connect(mapStateToProps)(PageBody);
